/**
* @author Ryan Gladstone
*/

function taskTypesService($http, $q, $translate, cacheService) {
  const service = {};

  service.getTaskTypes = () => {
    const deferred = $q.defer();

    $http.get('api/tasks/types', { cache: true })
      .success((data) => {
        deferred.resolve(data);
      })
      .error((data) => {
        deferred.reject(data);
      });

    return deferred.promise;
  };

  service.getTaskStatuses = () => {
    const deferred = $q.defer();

    $http.get('api/tasks/statuses', { cache: true })
      .success((data) => {
        data.forEach((status) => {
          const taskStatus = status;
          switch (taskStatus.id) {
            case 1:
              taskStatus.name = $translate.instant('TASK_META_GROUP_ASSIGNED');
              break;
            case 2:
              taskStatus.name = $translate.instant('TASK_META_USER_ASSIGNED');
              break;
            case 3:
              taskStatus.name = $translate.instant('TASK_META_CLAIMED');
              break;
            case 4:
              taskStatus.name = $translate.instant('TASK_META_REJECTED');
              break;
            case 5:
              taskStatus.name = $translate.instant('TASK_META_COMPLETED');
              break;
            default:
              taskStatus.name = taskStatus.name;
              break;
          }
        });
        deferred.resolve(data);
      })
      .error((data) => {
        deferred.reject(data);
      });

    return deferred.promise;
  };

  service.updateTaskType = (taskType) => {
    const deferred = $q.defer();

    $http.post('api/tasks/types', taskType)
      .success((data) => {
        cacheService.invalidateCache('tasks/types');
        deferred.resolve(data);
      })
      .error((data) => {
        deferred.reject(data);
      });

    return deferred.promise;
  };

  service.updateTaskStatus = (taskStatus) => {
    const deferred = $q.defer();
    // Prevent editing of default WebSked task statuses
    if (taskStatus.id > 5) {
      $http.post('api/tasks/statuses', taskStatus)
        .success((data) => {
          cacheService.invalidateCache('tasks/statuses');
          deferred.resolve(data);
        })
        .error((data) => {
          deferred.reject(data);
        });
    } else {
      deferred.reject(`${taskStatus.name} cannot be edited`);
    }
    return deferred.promise;
  };

  service.deleteTaskType = (taskTypeId) => {
    const deferred = $q.defer();

    $http.delete(`api/tasks/types/${taskTypeId}`)
      .success((data) => {
        cacheService.invalidateCache('tasks/types');
        deferred.resolve(data);
      })
      .error((data) => {
        deferred.reject(data);
      });

    return deferred.promise;
  };

  service.deleteTaskStatus = (taskStatusId) => {
    // Prevent deletion of default WebSked task statuses
    const deferred = $q.defer();
    if (taskStatusId > 5) {
      $http.delete(`api/tasks/statuses/${taskStatusId}`)
        .success((data) => {
          cacheService.invalidateCache('tasks/statuses');
          deferred.resolve(data);
        })
        .error((data) => {
          deferred.reject(data);
        });
    } else {
      deferred.reject('Status cannot be deleted');
    }

    return deferred.promise;
  };

  return service;
}

const arr = [
  '$http',
  '$q',
  '$translate',
  'cacheService',
  taskTypesService
];

module.exports = (ngModule) => {
  ngModule.service('taskTypesService', arr);
};
